import { z } from 'zod';
import { PermissionAction } from '../enums';

export const PermissionSchema = z.object({
  id: z.string().uuid(),
  code: z.string(),
  module: z.string(),
  action: z.nativeEnum(PermissionAction),
  scope: z.string().nullable(),
  description: z.string().nullable(),
  is_active: z.boolean(),
  created_at: z.string().datetime(),
});

export const CreatePermissionSchema = z.object({
  module: z.string().min(1, 'Module is required').max(100),
  action: z.nativeEnum(PermissionAction),
  scope: z.string().max(100).nullable().optional(),
  description: z.string().max(500).nullable().optional(),
});

export const UpdatePermissionSchema = z.object({
  description: z.string().max(500).nullable().optional(),
  is_active: z.boolean().optional(),
});

export type Permission = z.infer<typeof PermissionSchema>;
export type CreatePermission = z.infer<typeof CreatePermissionSchema>;
export type UpdatePermission = z.infer<typeof UpdatePermissionSchema>;
